import { ReactNode } from "react";

export const ModalFooter = ({ children, className }: { children?: ReactNode; className?: string; }) => {
    return (
        <div className={`modal-footer ${className}`}>
            {children}
        </div>
    );
};
